"use client";

import * as Collapsible from "@radix-ui/react-collapsible";
import { useState, type ReactNode } from "react";

import { AngleRightIcon } from "./icons/angle-right";
import { H3 } from "./typography";

export function TextCollapsible({
  title,
  children,
  defaultOpen = false,
}: {
  children: ReactNode;
  defaultOpen?: boolean;
  title: string;
}) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <Collapsible.Root open={open} onOpenChange={setOpen}>
      <Collapsible.Trigger className="group mb-4 flex items-center gap-2">
        <span className="shrink-0 rounded-full p-2 group-hover:bg-neutral-200">
          <AngleRightIcon className="group-data-open:rotate-90 transition-all" />
        </span>
        <H3 className="grow">{title}</H3>
      </Collapsible.Trigger>
      <Collapsible.Content className="space-y-4 pl-12">
        {children}
      </Collapsible.Content>
    </Collapsible.Root>
  );
}
